module.exports = __webpack_public_path__ + "static/media/vecteezyVector.1d5692ae.jpg";